export default {"src":"/_next/static/media/concept-logo-black-bg.38262266.svg","height":169,"width":170,"blurWidth":0,"blurHeight":0};